'use client';

import {
    useSingleTypeEditor,
    UseSingleTypeEditorType
} from "@/app/lib/hooks/use-editor/useSingleTypeEditor";
import {
    SiteEducation,
    SiteEducationInput
} from "@/app/lib/generated/graphql-types";
import { createContext, ReactNode, useContext } from "react";
import FloatingEditorMenu from "@/app/features/shared/__to_be_integrated/FloatingEditorMenu";
import LoadingSpinner from "@/app/__to_be_integrated/_____components/_NEW/LoadingSpinner";
import { toggleDraftMode } from "@/app/lib/actions/editing";
import { getSiteEducation } from "@/app/features/sites/education/data-access/querie";
import { SiteEducationSchema } from "@/app/features/sites/education/types/schema";
import { SiteEducationEditable } from "@/app/features/sites/education/types/types";
import { updateSiteEducation } from "@/app/features/sites/education/data-access/mutations";

const SiteEducationContext = createContext<UseSingleTypeEditorType<SiteEducationEditable> | undefined>(undefined);

export function useSiteEducationEditor() {
    const context = useContext(SiteEducationContext);
    if (!context) {
        throw new Error("useSiteEducation must be used within a SiteEducationProvider");
    }
    return context;
}

interface SiteEducationProviderProps {
    children: ReactNode;
    isDraftModeEnabled: boolean;
}

export default function SiteEducationProvider({ children, isDraftModeEnabled }: SiteEducationProviderProps) {
    const editor = useSingleTypeEditor<SiteEducation, SiteEducationEditable, SiteEducationInput>({
        schema: SiteEducationSchema,
        loadEntity: getSiteEducation,
        update: updateSiteEducation,
    })

    if (editor.isLoading) return <LoadingSpinner />

    return (
        <SiteEducationContext.Provider value={editor}>
            {children}
            <FloatingEditorMenu
                autosaveState={editor.autosaveState}
                isDraftModeEnabled={isDraftModeEnabled}
                toggleDraftMode={toggleDraftMode}
                hasChanges={editor.hasChanges}
                onPublish={editor.publish}
                onDiscard={editor.discardChanges}
            />
        </SiteEducationContext.Provider>
    )
}
